export function billingErrorMessage(failure, fallback) {
    const response = failure.response?.data;
    if (response?.code === 'CAPACITY_REDUCTION_BLOCKED' && response.details?.resources?.length) {
        return response.details.resources.map(resource => resource.key === 'maxEmployees'
            ? `Du har ${resource.currentCount} aktiva anställda. Den nya gränsen är ${resource.limit}. Inaktivera ${resource.requiredReduction} ${resource.requiredReduction === 1 ? 'anställd' : 'anställda'} innan du minskar tillägget. Historiken sparas.`
            : `Du har ${resource.currentCount} användare och ${resource.pendingInvitations} väntande inbjudningar. Den nya gränsen är ${resource.limit}. Frigör ${resource.requiredReduction} ${resource.requiredReduction === 1 ? 'inloggningsplats' : 'inloggningsplatser'} genom att ta bort företagsåtkomst eller återkalla inbjudningar.`
        ).join(' ');
    }
    return response?.error || fallback;
}
